import { accessCriteria } from '../util/authorization/index';
import { authRoles } from './roleGroups';

const DOCUMENT_TITLE = 'Tax-Payments';
export const TPRoutes = [
  {
    path: '/tax/payments/',
    name: 'Tax-Payments',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/TaxPayments.vue'),
    children: [
      {
        path: 'dashboard',
        name: 'Tax - Payments - Dashboard',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/payments/Payments.vue'),
      },
      // {
      //   path: 'largePayments',
      //   name: 'Tax - Payments - Dashboard',
      //   meta: {
      //     title: DOCUMENT_TITLE,
      //   },
      //   component: () => import('../views/tax/payments/largePayments.vue'),
      // },
      {
        path: 'reports',
        name: 'Tax - Payments - Reports',
        meta: {
          title: DOCUMENT_TITLE,
        },
        // we need to create component after getting mockup
        component: () => import('../views/tax/payments/Reports.vue'),
      },
      {
        path: 'utils',
        name: 'Tax - Payments - Utils',
        meta: {
          title: DOCUMENT_TITLE,
        },
        //  we need to create component after getting mockup
        component: () => import('../views/tax/payments/utils/Utils.vue'),
        children: [
          {
            path: 'checkreconciliation',
            name: 'Tax - Payments - Check Reconciliation',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/payments/utils/CheckReconcilationView.vue'),
          },
          {
            path: 'postingperiod',
            name: 'Tax - Payments - Posting Period',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/payments/utils/PostingPeriodView.vue'),
          },
          {
            path: 'overpayments',
            name: 'Tax - Payments - Overpayments & Refunds',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/payments/utils/OverpaymentsNRefundsView.vue'),
          },
          {
            path: 'createfiscalyear',
            name: 'Tax - Payments - Create New Fiscal Year',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/payments/utils/TaxPaymentCreateFiscalYear.vue'),
          },
        ],
      },
      {
        path: 'CcPayments',
        name: 'Tax - Payments - CC',
        meta: {
          title: DOCUMENT_TITLE,
        },

        component: () => import('../views/tax/payments/CcPayments.vue'),
      },
      {
        path: 'audit/',
        name: 'Tax - Payments-Auditing',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/tax/payments/paymentAuditTab.vue'),
        children: [
          {
            path: 'list',
            name: 'Tax - Payments - Audit',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/payments/paymentsAuditing.vue'),
          },
          {
            path: 'monthly-balance',
            name: 'Tax - Payments - Audit Monthly Balance',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/payments/auditMonthlyBalance.vue'),
          },
          {
            path: 'archived-reports',
            name: 'Tax - Payments - Archived Reports',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/tax/payments/archivedReports.vue'),
          },
        ],
      },
    ],
  },
];

TPRoutes.forEach((element, index) => {
  TPRoutes[index].beforeEnter = async (to, from, next) => {
    await accessCriteria([...authRoles.TaxRead, ...authRoles.PaymentsAuth], next);
  };
});

export default TPRoutes;
